module.exports = __webpack_public_path__ + "img/1sb_five_stars_selected_reseller_d.7f98cc6.svg";